// Keep values in sync with constants.scss
export const sidebarWidthExpanded = "300px";
